import 'alpinejs';

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.baseData = {
    modalCheckICOpen: false,
    modalPromoCodeOpen: false,
    modalTACisOpen: false,
    modalAlertOpen: false,
    modalStatusOpen: false,
    modalBannerOpen: false,
    reCaptchaPage: 'base',
    reCaptchaAction: '',
    reCaptchaKey: '',
    localeKeys: {
        recaptcha_failed: 'Please prove that you are not a robot by completing the captcha.',
        icno_empty: 'Please enter your 12-digit IC number.',
        icno_invalid: 'Please enter a valid 12-digit IC number.',
        agreed_term: 'Please agree with our terms & conditions before proceeding.',
        name_empty: 'Please enter your full name.',
        email_empty: 'Please enter your email address.',
        email_invalid: 'Please enter a valid email address.',
        contact_empty: 'Please enter your contact no.',
        contact_invalid: 'Your contact number must start with \'6\'.',
        confirm_details: 'Please make sure all details provided is true and correct before proceed.',
        tac_empty: 'Please check your registered email, for 6-digit verification TAC.',
        tac_invalid: 'Please enter a valid 6-digit verification TAC.',
        full_booked: 'Fully Booked',
        book_unavailable: 'Unavailable',
        book_now: 'Book Now',
    },
    toggleTAC(dispatch, ic_no) {
        setTimeout(() => {
            dispatch('toggle-modal-tac', { ic_no: ic_no });
        }, 1500);
    },
    logOut(event) {
        event.preventDefault();
        document.getElementById('logoutForm').submit();
    }
}

function executeReCaptcha() {
    return new Promise((resolve, reject) => {
        grecaptcha.ready(() => {
            grecaptcha.execute(baseData.reCaptchaKey, { action: baseData.reCaptchaPage }).then(token => {
                resolve(token);

                /**
                * removed this validation to rely on server custom 're_captcha' validator instead

                axios.get(baseData.reCaptchaAction + '?token=' + token)
                .then(response => {
                    if (response && response.data && response.data.success) {
                        resolve(token);
                    } else {
                        throw 'Google reCAPTCHA Failed';
                    }
                })
                .catch(error => {
                    reject();

                    console.error(error);

                    showNativeAlert(baseData.localeKeys.recaptcha_failed);
                });
                */
            });
        });
    });
}

window.checkICNo = function () {
    return {
        validateAction: '',
        enteredIcNo: '',
        acceptedTerm: false,
        isLoading: false,
        fetchICNoChecking(event, dispatch) {
            event.preventDefault();

            if (!this.enteredIcNo) {
                showNativeAlert(baseData.localeKeys.icno_empty);
                return false;
            } else if (!this.acceptedTerm) {
                showNativeAlert(baseData.localeKeys.agreed_term);
                return false;
            } else if (this.enteredIcNo.length != 12 || !(/^\d+$/.test(this.enteredIcNo))) {
                showNativeAlert(baseData.localeKeys.icno_invalid);
                return false;
            } else if (this.enteredIcNo && this.acceptedTerm) {
                this.isLoading = true;

                executeReCaptcha().then((token) => {
                    axios.post(this.validateAction, {
                        ic_no: this.enteredIcNo,
                        captcha: token,
                    })
                    .then(response => {
                        if (response.data.status) {
                            if (response.data.message) {
                                showNativeAlert(response.data.message);
                            }

                            if (!response.data.redirect && response.data.status === 'tac') {
                                dispatch('toggle-modal-tac', { ic_no: this.enteredIcNo });
                            } else {
                                window.location.replace(response.data.redirect);
                            }
                        } else {
                            this.isLoading = false;

                            if (response.data.message) {
                                showNativeAlert(response.data.message);
                            }
                        }
                    })
                    .catch(reject => {
                        console.error(reject);
                        console.error(reject.response);

                        this.isLoading = false;

                        showServerValidateError(reject);
                    });
                }).catch(() => {
                    this.isLoading = false;
                });
            }

            return false;
        }
    };
}

window.checkPromoCode = function () {
    return {
        validateAction: '',
        enteredPromoCode: '',
        isLoading: false,
        searchPromoCode(event, dispatch) {
            event.preventDefault();

            if (!this.enteredPromoCode) {
                return false;
            } else {
                this.isLoading = true;

                executeReCaptcha().then((token) => {
                    axios.post(this.validateAction, {
                        promo: this.enteredPromoCode,
                        captcha: token,
                    })
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.message) {
                            showNativeAlert(response.data.message);
                        }

                        if (response.data.status) {
                            this.enteredPromoCode = '';
                            dispatch('toggle-modal-promo-code');
                            dispatch('apply-promo-code', response.data.promo);
                        }
                    })
                    .catch(reject => {
                        console.error(reject);
                        console.error(reject.response);

                        this.isLoading = false;

                        showServerValidateError(reject);
                    });
                }).catch(() => {
                    this.isLoading = false;
                });
            }

            return false;
        }
    };
}

window.registerDriver = function () {
    return {
        isRegisterLoading: false,
        registerAction: '',
        acceptedTermRegister: false,
        firstName: '',
        lastName: '',
        userEmail: '',
        contactNo: '',
        icNo: '',
        fetchRegistration(event, dispatch) {
            event.preventDefault();

            if (!this.firstName) {
                showNativeAlert(baseData.localeKeys.name_empty);
                return false;
            } else if (!this.userEmail) {
                showNativeAlert(baseData.localeKeys.email_empty);
                return false;
            } else if (!isValidEmailAddress(this.userEmail)) {
                showNativeAlert(baseData.localeKeys.email_invalid);
                return false;
            } else if (!this.contactNo) {
                showNativeAlert(baseData.localeKeys.contact_empty);
                return false;
            } else if (this.contactNo.charAt(0) !== '6') {
                showNativeAlert(baseData.localeKeys.contact_invalid);
                return false;
            } else if (!this.acceptedTermRegister) {
                showNativeAlert(baseData.localeKeys.agreed_term);
                return false;
            }

            if (confirm(baseData.localeKeys.confirm_details)) {
                this.isRegisterLoading = true;

                executeReCaptcha().then((token) => {
                    let data = {
                        // ic_no: this.icNo,
                        email: this.userEmail,
                        first_name: this.firstName,
                        // last_name: this.lastName,
                        contact_no: this.contactNo,
                        captcha: token,
                    }

                    axios.post(this.registerAction, data)
                    .then(response => {
                        if (response.data.status) {
                            showNativeAlert(response.data.message);
                            dispatch('toggle-modal-tac', { ic_no: this.icNo });
                        } else {
                            this.isRegisterLoading = false;

                            if (response.data.message) {
                                showNativeAlert(response.data.message);
                            }
                        }
                    })
                    .catch(reject => {
                        console.error(reject);
                        console.error(reject.response);

                        this.isRegisterLoading = false;

                        showServerValidateError(reject);
                    });
                }).catch(() => {
                    this.isLoading = false;
                });
            }

            return false;
        },
        appendContactNo(event) {
            let oriValue = this.contactNo;

            if (oriValue && oriValue.indexOf('6') !== 0) {
                oriValue = '6' + oriValue;
            }

            this.contactNo = oriValue.replace(/[^0-9]/g, '');
        }
    }
}

window.handleTACCode = function () {
    return {
        tacReSendCountdown: 0,
        isTacLoading: false,
        tacAction: '',
        resendAction: '',
        tacCode: '',
        tacIcNo: '',
        initTAC(event) {
            this.tacIcNo = event.detail.ic_no;
            this.resetTACCountdown();
        },
        fetchTACValidate(event) {
            event.preventDefault();

            if (!this.tacCode) {
                showNativeAlert(baseData.localeKeys.tac_empty);
                return false;
            } else if (this.tacCode.length != 6 || !(/^\d+$/.test(this.tacCode))) {
                showNativeAlert(baseData.localeKeys.tac_invalid);
                return false;
            } else {
                this.isTacLoading = true;

                executeReCaptcha().then((token) => {
                    axios.post(this.tacAction, {
                        // ic_no: this.tacIcNo,
                        password: this.tacCode,
                        captcha: token,
                    })
                    .then(response => {
                        if (response.data.status) {
                            if (response.data.message) {
                                showNativeAlert(response.data.message);
                            }

                            window.location.replace(response.data.redirect);
                        } else {
                            this.isTacLoading = false;

                            if (response.data.message) {
                                showNativeAlert(response.data.message);
                            }
                        }
                    })
                    .catch(reject => {
                        console.error(reject);
                        console.error(reject.response);

                        this.isTacLoading = false;

                        showServerValidateError(reject);
                    });
                }).catch(() => {
                    this.isTacLoading = false;
                });
            }
        },
        reSendTACCode(event) {
            this.isTacLoading = true;

            executeReCaptcha().then((token) => {
                axios.post(this.resendAction, {
                    // ic_no: this.tacIcNo,
                    captcha: token,
                })
                .then(response => {
                    this.isTacLoading = false;

                    if (response.data.message) {
                        showNativeAlert(response.data.message);
                    }

                    this.resetTACCountdown();
                })
                .catch(reject => {
                    console.error(reject);
                    console.error(reject.response);

                    this.isTacLoading = false;

                    showServerValidateError(reject);
                });
            }).catch(() => {
                this.isTacLoading = false;
            });
        },
        resetTACCountdown() {
            this.tacReSendCountdown = 60;

            let timer = setInterval(() => {
                if (this.tacReSendCountdown > 0) {
                    this.tacReSendCountdown = this.tacReSendCountdown - 1;

                    if (this.tacReSendCountdown === 0) {
                        clearInterval(timer);
                    }
                }
            }, 1000);
        }
    }
}

window.trainingPage = function () {
    return {
        trainingsAction: '',

        trainingTitle: '',
        trainingDescription: '',

        psvAction: '',

        datePicker: '',
        selectedDate: '',

        selectedState: '',

        psvIsLoading: true,
        psvData: [],

        psvsPageNumber: 0,
        psvsSizePerPage: 8,
        psvsTotal: 0,

        otherData: [],
        othersPageNumber: 0,
        othersSizePerPage: 6,
        othersTotal: 0,

        minimumBookingDate: null,

        showStateClicked: false,

        initTrainings() {
            this.getPsvTrainings(true);

            this.datePicker = flatpickr('#date' , {
                disableMobile: true,
                locale: {
                    firstDayOfWeek: 1, // start week on Monday
                },
                altInput: true,
                altFormat: 'd-m-Y',
                dateFormat: 'Y-m-d',
                minDate: 'today',
                onChange: (selectedDates, dateStr, instance) => {
                    this.selectedDate = dateStr;
                    this.getPsvTrainings();
                }
            });
        },

        showSelectState() {
            this.showStateClicked = true;
        },

        hideSelectState() {
            this.showStateClicked = false;
        },

        stateOnChange(event) {
            this.selectedState = event.target.value;
            this.getPsvTrainings();
        },

        resetDatePicker(event) {
            this.selectedDate = '';
            this.datePicker.clear();
        },

        getBookingFull(psv) {
            return parseInt(psv.attendances_count) >= parseInt(psv.capacity);
        },

        getBookingDisabled(psv) {
            let blocked = false;

            if (parseInt(psv.booking_cutoff_days)) {
                if (!this.minimumBookingDate) {
                    this.minimumBookingDate = new Date().fp_incr(parseInt(psv.booking_cutoff_days));
                }

                blocked = !this.compareDatesGreaterThanEqual(this.datePicker.parseDate(psv.date, 'Y-m-d'), this.minimumBookingDate);
            }

            return blocked || this.getBookingFull(psv);
        },

        getBookingLink(psv) {
            if (this.getBookingDisabled(psv)) {
                return '#';
            }

            let url = this.psvAction;

            return url.replace('/0/', '/' + psv.hashed + '/');
        },

        getBookingLabel(psv) {
            if (this.getBookingFull(psv)) {
                return baseData.localeKeys.full_booked;
            } if (this.getBookingDisabled(psv)) {
                return baseData.localeKeys.book_unavailable;
            }

            return baseData.localeKeys.book_now;
        },

        getPsvTrainings(init = false) {
            this.psvIsLoading = true;

            let url = new URL(this.trainingsAction);
            let params = url.searchParams;

            if (init) {
                params.set('init', 1);
            }

            if (this.psvsSizePerPage) {
                params.set('size', this.psvsSizePerPage);
            }

            if (this.psvsPageNumber) {
                params.set('page', this.psvsPageNumber + 1);
            }

            if (this.selectedDate) {
                params.set('range', this.selectedDate);
            }

            if (this.selectedState) {
                params.set('state', this.selectedState);
            }

            url.search = params.toString();

            executeReCaptcha().then((token) => {
                axios.get(url.toString())
                .then(response => {
                    if (response.data.status) {
                        this.psvIsLoading = false;

                        this.trainingTitle = response.data.title;
                        this.trainingDescription = response.data.description;

                        this.psvData = response.data.psv;
                        this.psvsTotal = response.data.psv_total;

                        if (init) {
                            this.otherData = response.data.other;
                        }
                    } else {
                        this.psvIsLoading = false;

                        if (response.data.message) {
                            showNativeAlert(response.data.message);
                        }
                    }
                })
                .catch(reject => {
                    console.error(reject);
                    console.error(reject.response);

                    this.psvIsLoading = false;

                    // showServerValidateError(reject);
                });
            }).catch(() => {
                this.psvIsLoading = false;
            });
        },
        psvPages() {
            return Array.from({
                length: Math.ceil(this.psvsTotal / this.psvsSizePerPage),
            });
        },
        nextPsvPage() {
            this.psvsPageNumber++;
            this.getPsvTrainings();
        },
        prevPsvPage() {
            this.psvsPageNumber--;
            this.getPsvTrainings();
        },
        psvPageCount() {
            return Math.ceil(this.psvsTotal / this.psvsSizePerPage);
        },
        viewPsvPage(index) {
            this.psvsPageNumber = index;
            this.getPsvTrainings();
        },

        getFormattedDate(date) {
            let parsed = this.datePicker.parseDate(date, 'Y-m-d');

            return this.datePicker.formatDate(new Date(parsed), 'd M Y');
        },

        compareDatesGreaterThanEqual(date1, date2) {
            return new Date(date1.getTime()).setHours(0, 0, 0, 0) >= new Date(date2.getTime()).setHours(0, 0, 0, 0);
        },

        get othersCategories() {
            let start = this.othersPageNumber * this.othersSizePerPage;
            let end = end = start + this.othersSizePerPage;

            this.othersTotal = this.otherData.length;

            return this.otherData.slice(start, end);
        },
        otherPages() {
            return Array.from({
                length: Math.ceil(this.othersTotal / this.othersSizePerPage),
            });
        },
        nextOtherPage() {
            this.othersPageNumber++;
        },
        prevOtherPage() {
            this.othersPageNumber--;
        },
        otherPageCount() {
            return Math.ceil(this.othersTotal / this.othersSizePerPage);
        },
        viewOtherPage(index) {
            this.othersPageNumber = index;
        },
    }
}

window.bookingPage = function () {
    return {
        trainingPrice: 0,
        discountPrice: 0,
        discountTitle: null,
        finalPrice: 0,
        promoDiscount: null,
        submittingBooking: false,
        showPromoCode(event) {
            this.promoDiscount = event.detail;

            this.discountTitle = this.promoDiscount.title;
            this.discountPrice = this.promoDiscount.discount_amount;

            if (this.promoDiscount.is_percentage) {
                this.discountTitle += ` (${this.promoDiscount.discount_label} OFF)`;
                this.discountPrice = this.trainingPrice * (this.discountPrice / 100);
            }

            this.finalPrice = this.trainingPrice - this.discountPrice;

            if (this.finalPrice < 0) {
                this.finalPrice = 0;
            }
        },
        removePromoCode() {
            this.promoDiscount = null;
            this.discountPrice = 0;
            this.discountTitle = null;
            this.finalPrice = this.trainingPrice;
        }
    }
}

window.preparePayment = function () {
    return {
        postPayment() {
            document.getElementById('paymentForm').submit();
        }
    }
}

window.bannerCarousel = function () {
    return {
        container: null,
        prev: null,
        next: null,
        initCarousel() {
            this.container = this.$refs.banners;
            this.updateCarousel();
            this.container.addEventListener('scroll', this.updateCarousel.bind(this), { passive: true });
        },
        updateCarousel() {
            const rect = this.container.getBoundingClientRect();

            const visibleElements = Array.from(this.container.children).filter((child) => {
                const childRect = child.getBoundingClientRect();

                return childRect.left >= rect.left && childRect.right <= rect.right;
            });

            if (visibleElements.length > 0) {
                this.prev = this.getPrevElement(visibleElements);
                this.next = this.getNextElement(visibleElements);
            }
        },
        getPrevElement(list) {
            const sibling = list[0].previousElementSibling;

            if (sibling instanceof HTMLElement) {
                return sibling;
            }

            return null;
        },
        getNextElement(list) {
            const sibling = list[list.length - 1].nextElementSibling;

            if (sibling instanceof HTMLElement) {
                return sibling;
            }

            return null;
        },
        scrollTo(element) {
            const current = this.container;

            if (!current || !element) {
                return;
            }

            const nextScrollPosition = element.offsetLeft + element.getBoundingClientRect().width / 2 - current.getBoundingClientRect().width / 2;

            current.scroll({
                left: nextScrollPosition,
                behavior: 'smooth',
            });
        }
    };
}

function isValidEmailAddress(emailAddress) {
	var pattern = new RegExp(
		/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
	);

	return pattern.test(emailAddress);
}

function showServerValidateError(reject) {
    if (reject.response && reject.response.status === 422 && reject.response.data) {
        let errors = reject.response.data['errors'];

        if (errors) {
            let message = '';

            for (const key in errors) {
                if (errors.hasOwnProperty(key)) {
                    message = errors[key][0];
                    break;
                }
            }

            if (message) {
                showNativeAlert(message);
            }
        }
    }
}

function showNativeAlert(message) {
    alert(message.replace(/\\n/g, '\n\n'));
}

function ready(callbackFunc) {
    if (document.readyState !== 'loading') {
        // Document is already ready, call the callback directly
        callbackFunc();
    } else if (document.addEventListener) {
        // All modern browsers to register DOMContentLoaded
        document.addEventListener('DOMContentLoaded', callbackFunc);
    } else {
        // Old IE browsers
        document.attachEvent('onreadystatechange', function() {
            if (document.readyState === 'complete') {
                callbackFunc();
            }
        });
    }
}

ready(function() {});
